import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Atlas Chat Widget — iframe-based, DO NOT restyle the widget internals.
 * Theme is controlled in the Atlas Share dialog.
 * 
 * - Not logged in → Main board (public)
 * - Logged in as admin → Social Media board (admin)
 * - Logged in as non-admin → No widget
 */
const ChatBubble = () => {
  const { user, isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(max-width: 768px)').matches;
  });

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const isAdmin = user?.role === 'admin';
  const showWidget = (!isAuthenticated || isAdmin) && !isMobile;

  if (!showWidget) return null;

  const config = isAdmin
    ? {
        id: 'social',
        src: 'https://magicalnodes.com/embed/639c1994-2861-451a-8a46-6235397cb81b?key=pe_983f13fd88614379b85f6d6350787c62',
      }
    : {
        id: 'main',
        src: 'https://magicalnodes.com/embed/c0d22e48-1c85-4e75-81c4-f6f39b3548e9?key=pe_8c9914982daf4173b928322d941ceec3',
      };

  return (
    <>
      <style>{`
        #atlas-launcher-${config.id} {
          position: fixed; bottom: 24px; right: 24px;
          width: 56px; height: 56px; border-radius: 50%;
          background: #5a3a1d; color: #f3ead8;
          border: none; cursor: pointer; z-index: 2147483646;
          box-shadow: 0 10px 30px rgba(0,0,0,.3);
          font-size: 24px; display: flex; align-items: center; justify-content: center;
          transition: transform .2s ease;
          font-family: 'Oswald', 'Bebas Neue', sans-serif;
          font-weight: 700;
          letter-spacing: 1px;
        }
        #atlas-launcher-${config.id}:hover { transform: scale(1.05); }
        #atlas-widget-${config.id} {
          position: fixed; bottom: 96px; right: 24px;
          width: 380px; height: 560px; max-height: calc(100vh - 120px);
          border: 0; border-radius: 14px; z-index: 2147483647;
          box-shadow: 0 20px 50px rgba(0,0,0,.35);
          display: none;
        }
        #atlas-widget-${config.id}.open { display: block; }
        @media (max-width: 480px) {
          #atlas-widget-${config.id} { width: calc(100vw - 24px); right: 12px; bottom: 88px; }
        }
      `}</style>

      <button
        id={`atlas-launcher-${config.id}`}
        aria-label="Open chat"
        onClick={() => setOpen(!open)}
        data-testid="chat-bubble-btn"
      >
        {open ? '✕' : 'EM'}
      </button>

      <iframe
        id={`atlas-widget-${config.id}`}
        className={open ? 'open' : ''}
        src={config.src}
        allow="clipboard-write"
        title="Chat Widget"
        data-testid="chat-widget-iframe"
      />
    </>
  );
};

export default ChatBubble;
